<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <div class="control has-icons-left">
                    <input v-model="search" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
          <div class="column is-6">
            <div class="control has-icons-left">
              <multiselect v-model="school" label="name" name="schools" track-by="id" :options="schools" placeholder="Choose school"></multiselect>
            </div>
          </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}}
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                    <th v-if="actions">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items">
                    <td>{{item.id}}</td>
                    <td>{{item.provider_id}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.words}}</td>
                    <td>{{item.school.name}}</td>
                    <td v-if="actions" width="10%">
                        <router-link v-bind:to="{ name: 'sb-lesson', params: { id: item.id }}" class="button tooltip" data-tooltip="View">
                            <span class="icon">
                                <i class="fa fa-eye"></i>
                            </span>
                        </router-link>

                        <router-link @click.native.stop="" v-bind:to="{ name: 'sb-lesson-edit', params: { id: item.id }}" class="button is-warning tooltip" data-tooltip="Edit">
                            <span class="icon">
                                <i class="fa fa-edit"></i>
                            </span>
                        </router-link>

                        <button class="button is-danger tooltip" data-tooltip="Delete" @click="showDeleteModal($event, item.id, index)">
                            <span class="icon">
                                <i class="fa fa-trash"></i>
                            </span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'sb-lessons-table',
  props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: {required: false, default: false},
        //schools: {required: false, default: []}
  },
  components: {},
  data() {
        return {
            search: '',
            school: {},
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: 'id'
                },
                {
                    name: 'Provider id',
                    key: 'provider_id'
                },
                {
                    name: 'Name',
                    key: 'name'
                },
                {
                    name: 'Words',
                    key: 'words'
                },
              {
                name: 'School',
                key: 'school.name'
              },
            ],
            reverse: true,
        }
  },
  created(){
    if(this.schools.length == 0){
      this.loadSchools();
    }
  },
  methods: {
    sortBy(column) {

        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },
    onPageChanged(page){
        this.$emit("pageChanged", page);
    },
    onSchoolChanged(page){
      this.$emit("schoolChanged", page);
    },
    show(id){
        this.$router.push('/dashboard/' + 'sb-lessons/' + id);
    },
    showDeleteModal(event, id, index){
        event.stopPropagation();
        let self = this;
        this.$swal({
            title: 'Are you sure?',
            text: "This will delete this lesson permanently!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3273dc',
            cancelButtonColor: '#ff3860',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                self.deleteLesson(id, index);
            }
        }).catch((result) => {
        });

    },
    deleteLesson (id, index) {
        this.stbyLessonRepo.delete(id).then(response => {
            this.items.splice(index, 1);
            this.$swal(
                'Deleted!',
                'Lesson has been deleted.',
                'success'
            )
        });
    },
  },
  watch: {
      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800),

      'schools':function (schools) {
        if(schools.length > 0){
          this.school = schools[0];
        }
        //this.stbySchools(this.schools);
      },

      'school':function (school) {
        this.onSchoolChanged(school.id);
      },
  },
  computed: {
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/Table.vue